$shm_hitalama_map_widget_float_notebook_edit $shm_hitalama_map_widget_float_notebook
